import { render, staticRenderFns } from "./hizmet-sozlesmesi.vue?vue&type=template&id=3bf7c56c&"
import script from "./hizmet-sozlesmesi.vue?vue&type=script&lang=js&"
export * from "./hizmet-sozlesmesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports